export default {
  plural: 'Task members',
  timeTrackedTasks: 'Time tracked tasks',
  timeTrackedProject: 'Time tracked project'
};
